import React from 'react';

export const SettingsContent = ({
  title,
  description,
  action,
  icon,
  className = '',
  children,
  contentClassName = '',
}) => {
  return (
    <div className={`flex-col-left w-100-P ${className}`}>
      <div className={`flex-row items-center justify-between ${contentClassName}`}>
        <div className="flex-col-left">
          <div className="flex-row items-center gap-8">
            {icon}
            <h2 className="fs-16 fw-600 m-btm-0">{title}</h2>
          </div>
          <p className="text-gray-500 m-top-0 align-text-left" style={{ opacity: 0.45 }}>
            {description}
          </p>
        </div>
        {action}
      </div>
      {children}
    </div>
  );
};
